<script lang="babel">
export default {
  data () {
    return {
      drawer: true
    }
  }
}
</script>
<template lang="pug">
div
  v-navigation-drawer(
    v-model="drawer"
    fixed
    clipped
    app
    )
    v-list(dense)
      v-list-tile
        v-list-tile-action
          v-icon contacts
        v-list-tile-content
          v-list-tile-title
            router-link(to="/dashboard/documents") Documentos emitidos
  v-toolbar(
    color="primary"
    dark
    app
    :clipped-left="$vuetify.breakpoint.mdAndUp"
    fixed
    )
    v-toolbar-side-icon(@click.stop="drawer = !drawer")
    v-toolbar-title Molinor
  v-footer(
    color="secondary"
    app
    )
  v-content
    v-container(fluid)
      router-view
</template>
